import React, { Suspense } from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import Spinner from '@divvy-web/skylab.spinner'

import { useAuth } from '@sputnik/auth'
import { useExperiment } from '@sputnik/experiments'
import LegacyDashboard from '@sputnik/pages/Dashboard'

import CreditApplicationsDataGrid from './CreditApplicationsDataGrid'
import DashboardFooter from './DashboardFooter'
import DashboardHeader from './DashboardHeader'
import FileUploadStatusProvider from './FileUploadStatusProvider'
import styles from './styles.module.scss'

const Dashboard = () => {
  const [getClassName] = useNameFormatter('Dashboard')
  const { email } = useAuth()

  const { behaviorName, isInExperiment } = useExperiment({
    experiment: 'beep-credit-application-dashboard-redesign-experiment',
    inputId: email ?? '',
    bucketingKey: 'email',
  })

  if (!isInExperiment || behaviorName !== 'presentedRedesignedDashboard') {
    return <LegacyDashboard />
  }

  return (
    <Suspense fallback={<Spinner fullPage />}>
      <FileUploadStatusProvider>
        <div className={styles[getClassName('')]}>
          <DashboardHeader />
          <CreditApplicationsDataGrid />
          <DashboardFooter />
        </div>
      </FileUploadStatusProvider>
    </Suspense>
  )
}

export default Dashboard
